import type { AccountView } from "@kwp/contracts";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useId } from "react";
import { errorMessage, useTRPC } from "../../lib/api";
import { Button, ErrorText } from "../../ui";
import { accountColour } from "../inbox/model";

/** A mailbox's colour in the inbox (the bar on each row): pick one, or go back to the automatic one. */
export function AccountColor({ account }: { account: AccountView }) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const id = useId();
  const set = useMutation(
    trpc.accounts.setColor.mutationOptions({ onSuccess: () => queryClient.invalidateQueries({ queryKey: trpc.accounts.list.queryKey() }) }),
  );
  const shown = accountColour(account.id, account.color);
  return (
    <div className="flex items-center gap-2">
      <label htmlFor={id} className="sr-only">
        Colour of {account.address}
      </label>
      <input
        id={id}
        type="color"
        value={shown}
        disabled={set.isPending}
        onChange={(e) => set.mutate({ accountId: account.id, color: e.target.value.toLowerCase() })}
        className="h-8 w-10 cursor-pointer rounded border border-border bg-surface p-0.5"
      />
      {account.color === null ? null : (
        <Button variant="ghost" className="min-h-7 px-2 text-xs" disabled={set.isPending} onClick={() => set.mutate({ accountId: account.id, color: null })}>
          Automatic
        </Button>
      )}
      {set.isError ? <ErrorText>{errorMessage(set.error)}</ErrorText> : null}
    </div>
  );
}
